import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { adCampaignErrorHandler } from 'framework-asset-preview-lib/internal/objectTypes/0-31/utils';
const errorHandlersConfig = {
  [OBJECT_TYPE.AD_CAMPAIGN]: adCampaignErrorHandler
};
export function detectCustomError(objectTypeId, error) {
  const handler = errorHandlersConfig[objectTypeId];
  if (!handler) {
    return null;
  }
  return handler(error);
}